import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import authApiService from "../../services/authServices";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const Printcard = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const matchId = searchParams.get("matchId");
  // URL params like userId/full_name can be incorrect for home/away slot mapping.
  // Rendering ONLY matchId-based data (backend decides golfer1/golfer2).
  const userId = searchParams.get("userId");
  const opponentName = searchParams.get("full_name");
  const [matchData, setMatchData] = useState(null);

  useEffect(() => {
    if (matchId) fetchMatchData();
  }, []);

  const fetchMatchData = async () => {
    try {
      const response = await authApiService.get("printScheduleView", {
        matchId,
      });
      if (response && response.data) {
        setMatchData(response?.data);
      }
    } catch (err) {
      console.error("Error fetching match data:", err);
    }
  };
  console.log("matchData", matchData);

  const player1Id = String(matchData?.player1_id ?? "");
  const player2Id = String(matchData?.player2_id ?? "");
  const player1Name = matchData?.player1_name || "";
  const player2Name = matchData?.player2_name || "";
  const player1Level = matchData?.player1_player_level ?? "";
  const player2Level = matchData?.player2_player_level ?? "";
  const player1Icon = matchData?.player1_icon
    ? matchData.player1_icon.startsWith("/")
      ? matchData.player1_icon
      : `/${matchData.player1_icon}`
    : "/default.png";
  const player2Icon = matchData?.player2_icon
    ? matchData.player2_icon.startsWith("/")
      ? matchData.player2_icon
      : `/${matchData.player2_icon}`
    : "/default.png";
  const homeCourt = matchData?.player1_home_court || "";
  const homeRecord = matchData?.player1_record || "";
  const awayCourt = matchData?.player2_home_court || "";
  const awayRecord = matchData?.player2_record || "";
  return (
    <div className="page-container col-sm-9">
      <style>{`
                .view-profile-btn {
                    padding: 10px 15px;
                    border-radius: 100px;
                    display: inline-block;
                    font-size: 14px;
                    text-align: center;
                    text-decoration: none;
                    line-height: inherit;
                    font-weight: 500;
                    min-width: 80px;
                    border: solid 1px #ccc;
                }
                .view-profile-btn:not(.view-profile-btn--purple) {
                    background: #fff;
                    color: #333 !important;
                }
                .view-profile-btn:hover {
                    background: #333;
                    color: #fff !important;
                    border-color: #333;
                }
                .view-profile-btn--purple {
                    background: #b38ec1 !important;
                    color: #fff !important;
                    border-color: #b38ec1;
                }
                .view-profile-btn--purple:hover {
                    background: #a17dad !important;
                    color: #fff !important;
                    border-color: #a17dad;
                }
                .member-card-box {
                    box-shadow: 0 4px 12px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.08);
                    min-height: 285px;
                    padding: 12px;
                }
                .member-card-box .playerINfotitle,
                .member-card-box p,
                .member-card-box h3 {
                    color: #333 !important;
                }
                .member-card-box .playerINfotitle {
                    color: #7a9234 !important;
                }
            `}</style>
      <div className="section section-post">
        <div className="left">
          <h2 className="text-white">Post Your Results</h2>
        </div>
      </div>
      {/* Post Results Screen starts */}
      <form id="matchForm" className="pt-1">
        <div className="row mb-5">
          <div className="col-lg-4 mb-3">
            <div className="section">
              <div id="played-info" className="h-auto mb-3">
                <div className=" heading-golfer">
                  <label htmlFor="played">Date Played</label>
                  <img src="/images/date-played.png" alt="" />
                </div>
                {/* <input
                                    className='form-control h-auto'
                                    type="text"
                                    id="played"
                                    name="played"
                                    maxLength={12}
                                    defaultValue=""
                                /> */}
                <div>
                  <Calendar style={{ width: "100%" }} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8 mb-3">
            <div className="section">
              <div className=" heading-golfer" style={{ height: "54px" }}>
                <label className="pt-2"> Post Scores</label>
                <img src="/images/score.png" alt="" />
              </div>

              <div className="card bg-light">
                <div className="card-body post_scores_table">
                  <div className="table-responsive">
                    <table className="table text-nowrap">
                      <tr>
                        <td>
                          <img
                            className="align-middle"
                            style={{ width: 50 }}
                            src="/images/icon-12.png"
                          />
                          <b className="ml-2">{player1Name} &nbsp;</b>
                        </td>
                        <td>
                          <input
                            id="player1set1"
                            name="score.opponentRetired"
                            className="num-input"
                            type="text"
                            defaultValue=""
                            maxLength={1}
                          />
                          <input
                            id="player1set1sup"
                            name="score.opponentRetired"
                            className="super-input"
                            type="text"
                            defaultValue=""
                            maxLength={2}
                          />
                        </td>
                        <td>
                          <input
                            id="player1set2"
                            name="score.opponentRetired"
                            className="num-input"
                            type="text"
                            defaultValue=""
                            maxLength={1}
                          />
                          <input
                            id="player1set2sup"
                            name="score.opponentRetired"
                            className="super-input"
                            type="text"
                            defaultValue=""
                            maxLength={2}
                          />
                        </td>
                        <td>
                          <input
                            id="player1set3"
                            name="score.opponentRetired"
                            className="num-input"
                            type="text"
                            defaultValue=""
                            maxLength={1}
                          />
                          <input
                            id="player1set3sup"
                            name="score.opponentRetired"
                            className="super-input"
                            type="text"
                            defaultValue=""
                            maxLength={2}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <img
                            className="align-middle"
                            style={{ width: 50 }}
                            src="/images/icon-12.png"
                          />
                          <b className="ml-2">{player2Name} &nbsp;</b>
                        </td>
                        <td>
                          <input
                            id="player2set1"
                            name="score.opponentRetired"
                            className="num-input"
                            type="text"
                            defaultValue=""
                            maxLength={1}
                          />
                          <input
                            id="player2set1sup"
                            name="score.opponentRetired"
                            className="super-input-bottom"
                            type="text"
                            defaultValue=""
                            maxLength={2}
                          />
                        </td>
                        <td>
                          <input
                            id="player2set2"
                            name="score.opponentRetired"
                            className="num-input"
                            type="text"
                            defaultValue=""
                            maxLength={1}
                          />
                          <input
                            id="player2set2sup"
                            name="score.opponentRetired"
                            className="super-input-bottom"
                            type="text"
                            defaultValue=""
                            maxLength={2}
                          />
                        </td>
                        <td>
                          <input
                            id="player2set3"
                            name="score.opponentRetired"
                            className="num-input"
                            type="text"
                            defaultValue=""
                            maxLength={1}
                          />
                          <input
                            id="player2set3sup"
                            name="score.opponentRetired"
                            className="super-input-bottom"
                            type="text"
                            defaultValue=""
                            maxLength={2}
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="opponentSection m-0 bg-transparent py-0">
                    {/* Changes for Opponent Required */}
                    <div className="onecolw">
                      <fieldset>
                        <input
                          id="opponentRetired"
                          name="score.opponentRetired"
                          onclick="boxDisable();"
                          type="checkbox"
                          defaultValue={1}
                        />
                        <input
                          type="hidden"
                          defaultValue={1}
                          name="_score.opponentRetired"
                        />
                        <label className="checkboxlabel">
                          Opponent Retired
                        </label>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clear" />
        <div id="members" className="print-card-info">
          <div className="row">
            <div className="col-md-4 col-sm-6 mb-5 text-center items-self-stretch">
              <div className="player-info members-listing-desc memberBox-bg w-100 h-100 flu-box shadow member-card-box">
                <div className="clear"></div>
                <div className="subsection p1">
                  <div className="flu-box">
                    <div className="left">
                      <table className="show-profile-info">
                        <tbody>
                          <tr>
                            <td className="profile-img text-center">
                              <img src={player1Icon} alt="Profile" />
                              <Link
                                to={`/carter/profile?userId=${player1Id}`}
                                className="view-profile-btn"
                              >
                                Profile
                              </Link>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <h2
                                className="playerINfotitle"
                                title={player1Name}
                              >
                                {player1Name}
                              </h2>
                            </td>
                          </tr>
                          <tr>
                            <td align="center">
                              <h3>&nbsp;{player1Level} Rating</h3>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p
                      className="overflowText"
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Home Court:&nbsp;{" "}
                      <span className="greentext"> {homeCourt}</span> <br />
                      Season Record:&nbsp;
                      <span className="green">{homeRecord}</span> <br />
                      <Link
                        to={`/carter/schedule?userId=${player1Id}`}
                        className="msg-link"
                      >
                        Schedule
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 mb-5 text-center items-self-stretch">
              <div className="player-info members-listing-desc memberBox-bg w-100 h-100 flu-box shadow member-card-box">
                <div className="clear"></div>
                <div className="subsection p1">
                  <div className="flu-box">
                    <div className="left">
                      <table className="show-profile-info">
                        <tbody>
                          <tr>
                            <td className="profile-img text-center">
                              <img src={player2Icon} alt="Profile" />

                              <Link
                                to={`/carter/profile?userId=${player2Id}`}
                                className="view-profile-btn"
                              >
                                Profile
                              </Link>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <h2
                                className="playerINfotitle"
                                title={player2Name}
                              >
                                {player2Name}
                              </h2>
                            </td>
                          </tr>
                          <tr>
                            <td align="center">
                              <h3>&nbsp;{player2Level} Rating</h3>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p
                      className="overflowText"
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Home Court:<span className="greentext"> {awayCourt}</span>{" "}
                      <br />
                      Season Record: <span className="green">
                        {awayRecord}
                      </span>{" "}
                      <br />
                      <Link
                        to={`/carter/schedule?userId=${player2Id}`}
                        className="msg-link"
                      >
                        Schedule
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section" style={{ marginTop: 40 }}>
          <div className="buttons">
            <div className="post-btn left">
              <div className="buttonwrapper">
                <Link
                  to="#!"
                  type="button"
                  onClick={() => window.print()}
                  className="squarebutton"
                >
                  Print
                </Link>
              </div>
            </div>
            <div className="right">
              <hr width="120px" />
              <p align="center">{player1Name}'s Signature</p>
            </div>
            <div className="right">
              <hr width="120px" />
              <p align="center">{player2Name}'s Signature</p>
            </div>
            <div className="clear" />
            <div className="clear" />
          </div>
        </div>
        {/* Post Results Screen ends */}
      </form>
    </div>
  );
};

export default Printcard;
